import { render, staticRenderFns } from "./Tableinvoice.vue?vue&type=template&id=41722516&scoped=true&"
import script from "./Tableinvoice.vue?vue&type=script&lang=js&"
export * from "./Tableinvoice.vue?vue&type=script&lang=js&"
import style0 from "./Tableinvoice.vue?vue&type=style&index=0&id=41722516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41722516",
  null
  
)

export default component.exports